import { useI18n } from '@i18n/I18nProvider'
import { formatDate } from '@i18n/locale'
import { Button } from '@ui/Button'
import { Icon } from '@ui/Icon'

// Marcar la etapa como completada, en su ficha. Sin completar: un botón. Completada: la fecha
// en texto con un check (el estado nunca va solo por color) y la opción de desmarcar.
export const StageDone = ({ doneOn, onToggle }: { doneOn: string | undefined; onToggle: () => void }) => {
	const { t, locale } = useI18n()
	if (doneOn === undefined)
		return (
			<Button variant="secondary" onClick={onToggle}>
				<Icon name="check" className="size-5" />
				{t('stages.markDone')}
			</Button>
		)
	return (
		<div className="flex flex-wrap items-center gap-x-4 gap-y-1">
			<p className="flex items-center gap-2 font-semibold text-forest-800">
				<span className="flex size-7 items-center justify-center rounded-full bg-forest-700 text-white">
					<Icon name="check" className="size-4" />
				</span>
				{t('stages.doneOn', { date: formatDate(doneOn, locale) })}
			</p>
			<Button variant="ghost" onClick={onToggle} className="px-2">
				{t('stages.undo')}
			</Button>
		</div>
	)
}
